import React, { useEffect, useContext, useState } from 'react'
import TopMenu from '../GitHubComponents/TopMenu'
import { GrHomeRounded } from "react-icons/gr";
import { LuUser2, LuUsers2, LuUserPlus2, LuCalendar } from "react-icons/lu";
import { HiOutlineClipboard } from "react-icons/hi2";
import { fetchCountWithRole } from "../services"
import { MyContext } from '..';
import Overview from './Overview';
import Users from './Users';
import { Routes, Route } from "react-router-dom";
import EzStudentRegistration from '../components/Registration/EzStudentRegistration';
import Calendar from './Calendar';
import Whiteboard from './Whiteboard';
import Teams from './Teams';
import NewTeam from './NewTeam';

export default function Organization(props) {
    document.title = props.title
    const { backendUrl } = useContext(MyContext)
    const queryParameters = new URLSearchParams(window.location.search);
    const subscriberCode = queryParameters.get("subcode") || props.subCode
    const organizationCode = queryParameters.get("orgcode") || props.orgCode
    const username = queryParameters.get("username") || props.username
    const [role, setRole] = useState(null)
    const [overview] = useState({name: "overview", icon: GrHomeRounded})
    const [people, setPeople] = useState({name: "people", icon: LuUser2})
    const addUser = {name: "add user", icon: LuUserPlus2}
    const calendar = {name: "calendar", icon: LuCalendar}
    const whiteboard = {name: "whiteboard", icon: HiOutlineClipboard}
    const teams = {name: "teams", icon: LuUsers2}
    const menuItems = [overview]
    useEffect(() => {
        async function fetchCountData() {
            try {
                const data = await fetchCountWithRole(backendUrl, subscriberCode, username);
                setPeople(prevPeople => ({ ...prevPeople, count: data?.userCount }))
                setRole(data.role)
            } catch (error) {
                console.error('Error fetching Users data:', error);
            }
        }
        fetchCountData();
    }, [backendUrl, subscriberCode, username]);
    if(role === "A" || role === "I"){
        menuItems.push(people, teams, addUser, calendar, whiteboard)
    }
    return (
        <div className='git-organization-body'>
            <TopMenu items={menuItems} subCode={subscriberCode}/>
            <Routes>
                <Route path='' element={<Overview title={"Overview | Organization"} subCode={subscriberCode} orgCode={organizationCode}/>}/>
                <Route path='overview' element={<Overview title={"Overview | Organization"} subCode={subscriberCode} orgCode={organizationCode}/>}/>
                <Route path='people' element={<Users title={"People | Organization"} subCode={subscriberCode} username={props.username} role={role}/>}/>
                <Route path='teams' element={<Teams title={"Teams | Organization"} subCode={subscriberCode} username={props.username} role={role}/>}/>
                <Route path='new-team' element={<NewTeam title={"Create New Team | Organization"} subCode={subscriberCode} username={props.username} role={role}/>}/>
                <Route path='add user' element={<EzStudentRegistration title={"Add | People"} header={"Add Student"} subCode={subscriberCode} orgCode={organizationCode} isUsername={false}/>}/>
                <Route path='calendar' element={<Calendar subCode={subscriberCode} roleCode={role} username={username} />}/>
                <Route path='whiteboard' element={<Whiteboard subCode={subscriberCode} username={username} />}/>
            </Routes>            
        </div>
    )
}